import React, { useState, useEffect, useCallback } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./List.scss";
import Card from "react-bootstrap/Card";
import { IoIosArrowRoundForward } from "react-icons/io";
import Pagination from "react-bootstrap/Pagination";
import { getblogs } from "../../api/apiRequest";
import { NotificationManager } from "react-notifications";
import { useLangContext } from "../../context/languageContext";
import { Tag } from "../../utils/GTMPageTag";

import { useTranslation } from "react-i18next";

const List = () => {
  Tag("Blog - List")
  const { t } = useTranslation(["common","blog"]);

  const {hostLanguage} = useLangContext();
  const [Blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages,setTotalPages] = useState();
  const [pageButtonsToShow,setPageButtonShow] = useState();

  const getBannerImgLink = (img_link) => {
    try
    {
      let base_url = 'https://cleverdomizil.ch';
      let url = base_url + img_link?.split("httpdocs")[1];
      return url
    }
    catch(error)
    {
      console.error(error);
    }
  }
  
  const fetchingAllBlog = useCallback(async(pageNumber) => {
    try
    {
      let apiRes = await getblogs(pageNumber,hostLanguage);
      let responseData = await apiRes.json();
      
      if(responseData.res)
      { // alert();
        //setBlogs(responseData.data);

        const dataArr = Object.values(responseData.data.data).filter(obj => typeof obj === 'object');
        setBlogs(dataArr);
        setPageButtonShow(responseData.data.total);
        const totalPages = Math.ceil(Number(responseData.data.total) / Number(responseData.data.per_page));
        setTotalPages(totalPages);
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
        // NotificationManager.error('Something went wrong!', '',2000);
    }
  }, [hostLanguage]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchingAllBlog(newPage);
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const ellipsisKey = 'ellipsis';

    if (totalPages <= pageButtonsToShow)
    {
      // console.warn(1);
      for (let i = 1; i <= totalPages; i++)
      {
        pageNumbers.push(i);
      }
    }
    else
    {
      if (currentPage <= Math.ceil(pageButtonsToShow / 2))
      {
        for (let i = 1; i <= pageButtonsToShow - 1; i++)
        {
          pageNumbers.push(i);
        }
        pageNumbers.push({ key: ellipsisKey });
        pageNumbers.push(totalPages);
      }
      else if (currentPage >= totalPages - Math.floor(pageButtonsToShow / 2))
      {
        pageNumbers.push(1);
        pageNumbers.push({ key: ellipsisKey });
        for (let i = totalPages - pageButtonsToShow + 2; i <= totalPages; i++)
        {
          pageNumbers.push(i);
        }
      }
      else
      {
        pageNumbers.push(1);
        pageNumbers.push({ key: ellipsisKey });
        for (let i = currentPage - Math.floor(pageButtonsToShow / 2) + 1; i <= currentPage + Math.floor(pageButtonsToShow / 2) - 1; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push({ key: ellipsisKey });
        pageNumbers.push(totalPages);
      }
    }
    return pageNumbers;
  };

  useEffect(()=>{
    fetchingAllBlog(1);
  },[fetchingAllBlog])

const formatDate = (inputDate) => {
  
  const date = new Date(inputDate);
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  return date.toLocaleDateString('en-GB', options).replace(/\//g, '.');

}

  const truncateText = (text, maxLength) => {
    const words = text.split(' ');
  
    if (words.length > maxLength) {
      return words.slice(0, maxLength).join(' ') + '...';
    }
  
    return text;
  };

  return (
    <div id="Blog" className="BlogBody">
      <Container className="BlogContainer">
        <Row>
          <Col sm={12}>
            <div className="ScetionTitel">
              <h2>{t('blog:title')}</h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <div className="BlogList">
              <ul>
                {Blogs?.length > 0 ? (
                  Blogs && Blogs?.map((item,index)=>{ 
                    const htmlContent = item?.description;
                    const htmlContent2 = truncateText(htmlContent, 30);
                    return(
                      <li key={index}>
                        <Card className="BlogBox">
                          <Card.Img variant="top" src={getBannerImgLink(item?.image)} />
                          <Card.Body>
                            <h5>{formatDate(item?.created_at)}</h5>
                            <h4>
                              {item?.title}
                            </h4>
                            {/*  {item?.description} */}
                            <p dangerouslySetInnerHTML={{ __html: htmlContent2 }} />
                            <a style={{cursor:'pointer'}} className="view-link" href={"blog/entry/"+item?.id}>
                              {/* Learn more <IoIosArrowRoundForward size={30} /> */}
                              {t('blog:learn_more')}<IoIosArrowRoundForward size={30} />
                            </a>
                          </Card.Body>
                        </Card>
                      </li>
                    )
                })):(
                  //  <> No Record Found</>
                  <>{t('blog:no_record_found')}</>
                )}
              </ul>
            </div>
            <Col className="FullCol">
              {Blogs?.length > 0 ? (
                <div className="TablePagination">
                    {/* Pagination controls start */}
                    <Pagination>
                      {currentPage >= 1 && (
                        <Pagination.Prev
                          disabled={currentPage === 1}
                          onClick={() => handlePageChange(currentPage - 1)}
                          style={{ cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                        />
                      )}
                      
                      {getPageNumbers().map((pageNumber, index) => (
                        <React.Fragment key={index}>
                          {pageNumber.key === 'ellipsis' ? (
                            <Pagination.Ellipsis key={index} />
                          ) : (
                            <Pagination.Item
                              key={index}
                              active={currentPage === pageNumber}
                              onClick={() => handlePageChange(pageNumber)}
                            >
                              {pageNumber}
                            </Pagination.Item>
                          )}
                        </React.Fragment>
                      ))}

                      {currentPage <= totalPages && (
                        <Pagination.Next
                          disabled={currentPage === totalPages}
                          onClick={() => handlePageChange(currentPage + 1)}
                          style={{ cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                        />
                      )}
                    </Pagination>
                  {/* Pagination controls end */}
                </div>
              ):null}
            </Col>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default List;
